import { useEffect } from "react"

// Client-side <title> for pages without a server SEO hook (catalog, author)
export function usePageTitle(title) {
  useEffect(() => {
    if (!title) return
    const full = /aldoo/i.test(title) ? title : `${title} | Aldoo`
    if (document.title !== full) document.title = full
  }, [title])
}
